// AR
export const reservasSmallHc = {
  createAlerta: {
    title: "إنشاء تذكير جديد",
    infoHeading: "معلومات التذكير",
    selectPropertyLabel: "اختر العقار الذي تريد تعيين التذكير له",
    dayLabel: "اختر يومًا من الأسبوع:",
    dayMonday: "الإثنين",
    dayTuesday: "الثلاثاء",
    dayWednesday: "الأربعاء",
    dayThursday: "الخميس",
    dayFriday: "الجمعة",
    daySaturday: "السبت",
    daySunday: "الأحد",
    selectTimeLabel: "اختر الوقت",
    sendAtLabel: "سيُرسل في:",
    minutesLabel: "مع {minutes} دقيقة:",
    previewPre: "سيُرسل التنبيه إلى النزلاء أيام",
    previewMid: "في الساعة",
    descriptionLabel: "وصف التنبيه",
    descriptionPlaceholder: "أدخل وصفًا للتنبيه",
    messageTypeLabel: "اختر نوع الرسالة التي ستُرسل.",
    messageTypeSimple: "رسالة بسيطة",
    messageTypeLink: "رسالة مع رابط في النهاية",
    messageTypeFile: "رسالة مع ملف مرفق في النهاية",
    linkFieldLabel: "أدخل الرابط الذي سيُرسل مع التذكير",
    fileFieldLabel: "حمّل الملف الذي سيُرسل مع التذكير",
    fileNameLabel: "اسم الملف",
    cancel: "إلغاء",
    save: "حفظ التذكير",
    errorDayRequired: "اليوم مطلوب",
    errorTimeRequired: "الوقت مطلوب",
    errorSelectMinutes: "اختر الدقائق",
    errorDescriptionRequired: "الوصف مطلوب",
    errorAttachmentRequired: "المرفق مطلوب أو اختر أن يكون نوع الرسالة بسيطًا",
  },
  reservationData: {
    statusConfirmed: "مؤكَّد",
    statusRejected: "مرفوض",
    statusTentative: "رهن التوفر",
    statusWithinCheckin: "ضمن مواعيد تسجيل الدخول",
    statusFree: "بدون تكلفة",
    modalTitleApprove: "الموافقة على الطلب؟",
    modalTitleApproveTime: "الموافقة في وقت آخر؟",
    modalTitlePrioritize: "إعطاء الأولوية لتسجيل الدخول هذا؟",
    modalTitleReject: "رفض الطلب؟",
    modalTitleDefault: "تأكيد؟",
    modalTextApprove: "أنت على وشك الموافقة على تسجيل الدخول المبكر لـ",
    modalTextApproveTime: "ستؤكد تسجيل الدخول في الوقت الذي تحدده لـ",
    modalTextPrioritize: "سنخبره بأنكم ستبذلون كل ما في وسعكم ليكون جاهزًا في ذلك الوقت، مع أن ذلك يعتمد على مغادرة النزيل السابق والتنظيف. سيُرسل إلى",
    modalTextReject: "أنت على وشك رفض تسجيل الدخول المبكر لـ",
    modalTextDefault: "تأكيد لـ",
    modalCtaApprove: "نعم، الموافقة",
    modalCtaApproveTime: "تأكيد الوقت",
    modalCtaPrioritize: "نعم، إبلاغ",
    modalCtaReject: "نعم، رفض",
    modalCtaDefault: "تأكيد",
    kpiRoom: "غرفة",
    kpiLodging: "مكان الإقامة",
    guestsCount: "نزيل | نزلاء",
    adultsCount: "بالغ | بالغون",
    childrenCount: "طفل | أطفال",
    infantsCount: "رضيع | رُضّع",
    roomsCountValue: "{count} غرف",
    holderRole: "صاحب الحجز",
    noEmail: "لا يوجد بريد إلكتروني معيَّن",
    writeWhatsapp: "المراسلة عبر واتساب",
    noPhoneTitle: "بدون رقم هاتف لا يمكن الإرسال عبر واتساب. يمكنك إضافته في «تعديل الحجز».",
    noPhone: "لا يوجد هاتف معيَّن",
    kpiCheckin: "تسجيل الدخول",
    kpiCheckout: "تسجيل الخروج",
    earlyRequested: "طُلب تسجيل دخول مبكر",
    arrivalRequested: "طُلب وقت الوصول",
    arrivesAt: "يصل في الساعة {time}",
    actionApprove: "موافقة",
    actionOtherTime: "وقت آخر",
    actionPrioritize: "إعطاء الأولوية",
    actionReject: "رفض",
    awaitingPayment: "في انتظار دفع النزيل",
    cannotUndo: "لا يمكن التراجع عن هذا الإجراء.",
    checkinTimeLabel: "وقت تسجيل الدخول",
    earlyPrioritisedTitle: "تسجيل دخول مبكر ذو أولوية",
    earlyApprovedTitle: "تمت الموافقة على تسجيل الدخول المبكر",
    earlyRejectedTitle: "تم رفض تسجيل الدخول المبكر",
    earlyLineApproved: "سيصل الساعة {time}",
    earlyLineApprovedOther: "سيصل الساعة {time} · طلب الساعة {original}",
    earlyLineRejected: "طلب الساعة {time} · سيسجّل الدخول في الوقت المعتاد",
    earlyLineRejectedStd: "طلب الساعة {time} · سيسجّل الدخول في الوقت المعتاد ({std})",
    earlyLinePrioritised: "يريد الوصول الساعة {time} · أخبرناه أننا سنبذل ما بوسعنا",
    extRequestedTitle: "طلب تمديد الإقامة",
    extAwaitingTitle: "تمديد الإقامة بانتظار الدفع",
    extConfirmedTitle: "تم تأكيد تمديد الإقامة",
    extNights: "الليالي المضافة: {nights} · المغادرة الجديدة {date}",
    extAtProperty: "{amount} للدفع في مكان الإقامة",
    extPendingHost: "بانتظار موافقتك",
    lateRequestedTitle: "طلب تسجيل مغادرة متأخر",
    lateAwaitingTitle: "تسجيل المغادرة المتأخر بانتظار الدفع",
    lateConfirmedTitle: "تم تأكيد تسجيل المغادرة المتأخر",
    lateRejectedTitle: "تم رفض تسجيل المغادرة المتأخر",
    lateLeavesAt: "يغادر الساعة {time}",
    lateWantsToLeave: "يريد المغادرة الساعة {time}",
    lateInsteadOf: "(بدلاً من {std})",
    latePaid: "مدفوع: {amount}",
    lateCourtesy: "ساعة مجانية دون تكلفة",
    lateFree: "دون تكلفة",
    lateCash: "{amount} نقداً عند المغادرة",
    lateUnpaid: "{amount}، لم يُدفع بعد",
    lateLineRejected: "طلب المغادرة الساعة {time} · يغادر في الموعد المعتاد",
    lateLineRejectedStd: "طلب المغادرة الساعة {time} · يغادر في الموعد المعتاد ({std})",
    requestedTimeHint: "طلب النزيل الساعة {time}",
    toastApproved: "تمت الموافقة على تسجيل الدخول المبكر",
    toastApprovedTime: "تمت الموافقة على وقت دخول جديد",
    toastPrioritised: "تم منح الأولوية لتسجيل الدخول المبكر",
    toastRejected: "تم رفض تسجيل الدخول المبكر",
    toastNotified: "لقد راسلنا النزيل بالفعل.",
    toastNotNotified: "تعذّر إبلاغ النزيل: يُرجى مراسلته بنفسك.",
    toastAlreadyDecided: "هذا الطلب تم البت فيه مسبقًا: لم تتم مراسلة النزيل مرة أخرى.",
    toastError: "تعذّر حفظ القرار. حاول مرة أخرى.",
    toastAlreadyPaid: "كان مدفوعًا بالفعل: لم يتم تحصيل المبلغ مرة أخرى.",
    toastRefundMaybeDue: "دفع مقابل الدخول المبكر وسيدخل الآن في الوقت المعتاد: أعد له المبلغ إذا لزم الأمر.",
    actionReadyNow: "يمكنه الدخول الآن",
    actionNotPossible: "لن يكون ذلك ممكنًا",
    toastPaymentLinkFailed: "تعذّر إنشاء رابط الدفع: يُرجى تحصيله بطريقة أخرى.",
    arrivalApprovedTitle: "تم تأكيد وقت الوصول",
    arrivalRejectedTitle: "تم رفض وقت الوصول",
    arrivalLineRejected: "طلب الوصول الساعة {time}",
    modalTextApproveArrival: "ستؤكد وقت وصول",
    modalTextRejectArrival: "سترفض وقت وصول",
    toastArrivalApproved: "تم تأكيد وقت الوصول",
    toastArrivalRejected: "تم رفض وقت الوصول",
    cancel: "إلغاء",
  },
  minStayModal: {
    summaryNoData: "لا توجد بيانات في النطاق المحدد",
    summaryHintMixed: "تم اكتشاف عدة حدود دنيا للإقامة في النطاق. يُضبط الحقل على ليلة واحدة لتحدد القيمة الجديدة.",
    summaryHintSingle: "تم تحميل الحقل بالحد الأدنى الحالي للإقامة في النطاق المحدد.",
    errorMinOne: "يجب أن يكون الحد الأدنى للإقامة ليلة واحدة على الأقل.",
    opStartLabel: "جارٍ تغيير الحد الأدنى للإقامة…",
    successUpdated: "تم تحديث الحد الأدنى للإقامة بنجاح",
    errorUpdate: "خطأ في تحديث الحد الأدنى للإقامة",
    errorUnknown: "خطأ غير معروف",
    title: "الحد الأدنى للإقامة",
    description: "اضبط الحد الأدنى للإقامة بالليالي لنطاق التواريخ المحدد.",
    detectedLabel: "الحدود الدنيا للإقامة المكتشفة",
    minStayLabel: "الحد الأدنى للإقامة (ليالٍ)",
    decreaseAria: "إنقاص الحد الأدنى للإقامة",
    minNightsPlaceholder: "مثال: 2",
    increaseAria: "زيادة الحد الأدنى للإقامة",
    hint: "الحد الأدنى لعدد الليالي التي يجب أن يحجزها النزيل.",
    cancel: "إلغاء",
    save: "حفظ",
  },
  modalCompleteReservation: {
    errorContactRequired: "للمتابعة يجب ملء أحد الحقلين (الهاتف أو البريد الإلكتروني)",
    successMsg: "تم إكمال بيانات الحجز بنجاح",
    successTitle: "تمت العملية بنجاح",
    title: "إكمال الحجز",
    bookingDateLabel: "تواريخ الحجز",
    checkin: "تسجيل الدخول",
    checkout: "تسجيل الخروج",
    phoneRequiredHint: "* الحقل الوحيد المطلوب",
    emailHint: "*إذا أدخلت البريد الإلكتروني فلن يضطر العميل إلى إدخاله",
    responsibleLabel: "أدخل اسم الشخص المسؤول",
    responsiblePlaceholder: "المسؤول عن الحجز",
    scheduleLabel: "حدد موعد إرسال رابط تسجيل الدخول.",
    scheduleAuto: "إرسال تلقائي",
    schedule24: "24 ساعة قبل تسجيل الدخول",
    schedule48: "48 ساعة قبل تسجيل الدخول",
    schedule72: "72 ساعة قبل تسجيل الدخول",
    scheduleWeek: "أسبوع واحد قبل تسجيل الدخول",
    cancel: "إلغاء",
    complete: "إكمال الحجز",
  },
  payData: {
    errorNoPaymentRecord: "تعذّر تحديد سجل الدفع.",
    partialLinkGenerated: "تم إنشاء رابط الدفع بنجاح.",
    errorGenerateLink: "تعذّر إنشاء الرابط.",
    partialRegistered: "تم تسجيل الدفعة الجزئية.",
    errorSavePartial: "تعذّر حفظ الدفعة الجزئية.",
    whatsappPartialMsg: "مرحبًا {name}، نشاركك الرابط لإكمال الدفعة المتبقية لحجزك: {url}",
    errorInvoicingNotActive: "الفوترة الإلكترونية غير مُفعّلة في باقتك.",
    fieldBillingProfile: "ملف الفوترة",
    fieldCountry: "الدولة",
    fieldLegalName: "الاسم القانوني",
    fieldTaxId: "NIF/CIF/NIT",
    fieldAddressStreet: "العنوان",
    fieldAddressCity: "المدينة",
    fieldAddressRegion: "المنطقة",
    fieldAddressZip: "الرمز البريدي",
    fieldEmail: "البريد الإلكتروني",
    fieldIsActive: "تفعيل الملف",
    errorBillingIncomplete: "أكمل بيانات الفوترة الخاصة بك. الناقص: {fields}",
    invoiceLinkCopied: "تم نسخ رابط الفوترة.",
    reservationHasInvoice: "هذا الحجز لديه فاتورة بالفعل.",
    errorLoadReceipt: "تعذّر تحميل الإيصال.",
    errorDownloadReceipt: "تعذّر تنزيل الإيصال.",
    guestOutOfWindow: "النزيل خارج نافذة واتساب لمدة 24 ساعة.",
    errorSendReceipt: "خطأ في إرسال الإيصال.",
    charge: "رسم",
    lodging: "مكان الإقامة",
    servicesExtras: "الخدمات والإضافات",
    free: "مجاني",
    ivaIncluded: "(ضريبة القيمة المضافة {rate}% مشمولة)",
    includedInPrice: "(مشمولة في السعر)",
    pendingCharge: "دفعة معلّقة",
    viewBreakdown: "عرض تفصيل الأسعار",
    viewReceipt: "عرض الإيصال",
    receiptInfoPre: "إيصال إعلامي. تُصدر الفاتورة الإلكترونية من تبويب",
    chargesTab: "الرسوم",
    receiptInfoNoInvoice: "الإيصال الإعلامي متاح. للفوترة الإلكترونية، اضبط بيانات الفوترة الخاصة بك.",
    reservationNumber: "الحجز رقم {code}",
    currentStatus: "الحالة الحالية",
    willChangeTo: "سيتغير إلى:",
    saving: "جارٍ الحفظ…",
    breakdownTitle: "تفصيل الأسعار",
    discounts: "الخصومات",
    taxesAndFees: "الضرائب والرسوم",
    ivaIncludedInPrice: "ضريبة القيمة المضافة ({rate}%) مشمولة في السعر: {amount}",
    includesTaxes: "يشمل {amount} من الضرائب المشمولة في السعر",
    total: "الإجمالي",
    close: "إغلاق",
    loadingReceipt: "جارٍ تحميل الإيصال…",
    stayReceipt: "إيصال الإقامة · {date}",
    downloadPdf: "تنزيل PDF",
    sending: "جارٍ الإرسال…",
    sent: "تم الإرسال!",
    outOfWindow: "خارج نافذة الـ 24 ساعة",
    sendWhatsapp: "الإرسال عبر واتساب",
    stayDetail: "تفاصيل الإقامة",
    ivaIncludedShort: "ضريبة القيمة المضافة {rate}% مشمولة",
    discount: "خصم",
    nightsCount: "ليلة | ليالٍ",
    additionalCharges: "رسوم إضافية",
    ivaShort: "ضريبة القيمة المضافة {rate}%",
    charged: "المحصّل",
    pending: "المتبقي",
    receiptGeneratedBy: "تم إنشاء الإيصال بواسطة",
    done: "تم",
    registerPartial: "تسجيل دفعة جزئية",
    reservationTotal: "إجمالي الحجز",
    amountReceived: "المبلغ المستلم بالفعل",
    paid: "المدفوع",
    pendingBalance: "الرصيد المتبقي",
    amountExceedsTotal: "المبلغ المستلم يتجاوز الإجمالي. استخدم الحالة",
    paidStatus: "مدفوع",
    internalNote: "ملاحظة داخلية",
    optional: "(اختياري)",
    notePlaceholder: "مثال: تم استلام الدفعة الأولى عبر تحويل بنكي...",
    autoLinkNote: "عند الحفظ، سيتم تحديث رابط الدفع تلقائيًا إلى",
    cancel: "إلغاء",
    savePartial: "حفظ الدفعة الجزئية",
    roomsCount: "{count} غرفة | {count} غرف",
    groupNotePre: "مبلغ",
    groupNoteCombined: "الحجز المُجمَّع",
    groupNoteMid: "التفصيل حسب الغرفة أدناه.",
  },
};
